// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"SubTitle-module--subTitle--hzb5g"};